import { Component } from '@angular/core';

@Component({
  selector: 'unh-simple-tabs-tab',
  styleUrls: ['./simple-tabs-tab.component.scss'],
  template: `
    <ng-content></ng-content>
  `
})
export class SimpleTabsTabComponent {}
